module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Kandidaten":"The candidate","har skrivit till er i poolen":"has written to you in the candidate pool"},"sv":{"Kandidaten":"Kandidaten","har skrivit till er i poolen":"har skrivit till er i kandidatpoolen"}}')
  delete Component.options._Ctor
}
